<template>
  <v-menu offset-y open-on-hover :open-delay="openDelay">
    <template v-slot:activator="{ on }">
      <v-hover>
        <v-icon v-on="on" slot-scope="{ hover }" :size="small ? minSize : null" class="clickable" :color="hover ? activeColor : color">
          info_outline
        </v-icon>
      </v-hover>
    </template>
    <v-card>
      <v-card-text>
        <slot>
          <div v-html="text"></div>
        </slot>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      color: String,
      activeColor: {
        type: String,
        default: 'info',
      },
      small: Boolean,
      text: String,
      openDelay: {
        type: Number,
        default: 0,
      },
    },
    data: () => ({
      minSize: 21, // smaller size gets pixelated
    }),
  }
</script>